import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel, Pill } from "@/components/admin/AdminUI";
import ConfirmDialog from "@/components/admin/ConfirmDialog";
import { CodesTable } from "@/components/admin/launch/InviteCodesTab";
import { api } from "@/lib/api";
import { formatDate, humanize } from "@/lib/format";

// Launch facts on the Profile tab: Founding Crush (Owner can grant/revoke), signup invite, referral codes.
export default function LaunchFacts({ data, isOwner, onChanged }) {
  const f = data.founding || {};
  const inv = data.signup_invite;
  const [ask, setAsk] = useState(false);
  const toggle = async () => {
    await api(`/admin/founding/${data.user.id}/${f.founding_crush ? "revoke" : "grant"}`, { method: "POST" });
    toast.success(f.founding_crush ? "Founding Crush revoked." : "Founding Crush granted.");
    onChanged();
  };
  return (
    <Panel className="p-6" data-testid="user-launch-facts">
      <h2 className="mb-4 font-semibold">Launch</h2>
      <dl className="grid gap-x-8 gap-y-4 text-sm sm:grid-cols-2 lg:grid-cols-3">
        <div><dt className="cw-muted text-xs">Founding Crush</dt>
          <dd className="mt-1 flex items-center gap-2" data-testid="user-founding">{f.founding_crush ? <Pill tone="brand">{f.number ? `#${f.number}` : "Yes"} · {humanize(f.source || "auto")}</Pill> : "No"}
            {isOwner && <Button size="sm" variant="ghost" onClick={() => setAsk(true)} data-testid="user-founding-toggle-button">{f.founding_crush ? "Revoke" : "Grant"}</Button>}</dd></div>
        <div><dt className="cw-muted text-xs">Signed up with</dt>
          <dd className="mt-1" data-testid="user-signup-invite">{inv ? `${humanize(inv.kind || "invite")} code${inv.wave_id ? ` · wave ${inv.wave_id}` : ""}${inv.owner_user_id ? ` · from ${inv.owner_user_id}` : ""}` : "No invite code"}</dd></div>
        <div><dt className="cw-muted text-xs">Referral codes</dt><dd className="mt-1">{data.referral_codes?.length || 0}</dd></div>
      </dl>
      {data.referral_codes?.length > 0 && <div className="-mx-6 mt-4 border-t border-border"><CodesTable items={data.referral_codes} testId="user-referral-codes" /></div>}
      <ConfirmDialog open={ask} onOpenChange={setAsk} destructive={!!f.founding_crush} testId="user-founding-confirm-dialog" onConfirm={toggle}
        title={f.founding_crush ? "Revoke the Founding Crush badge?" : "Grant the Founding Crush badge?"} confirmLabel={f.founding_crush ? "Revoke" : "Grant"}
        description={f.founding_crush ? "The badge disappears from their profile." : "Manual grants don’t use up the automatic count."} />
    </Panel>
  );
}
